module.exports = __webpack_public_path__ + "static/media/upload.07fc6124.svg";